import React from 'react';

import { Icon } from '../icons';

export const PictureSpotIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 40 40" stroke={color} style={style} fill="none">
      <g>
        <path d="M25.625 10H35V32.5H5V21.9531" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12.5" cy="12.5" r="6.25" strokeWidth="1.5" />
        <path d="M12.5 16.25V21.875" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M12.5 3.75V9.375" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M21.5625 12.5L15.9375 12.5" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M9.375 12.5L3.75 12.5" strokeWidth="1.5" strokeLinecap="round" />
        <path
          strokeWidth="0.1"
          fill={color}
          d="M29.375 18.75L28.8447 18.2197L29.4036 17.6607L29.9325 18.2483L29.375 18.75ZM22.5 25.625L23.0303 26.1553L22.6253 26.5604L22.1279 26.2762L22.5 25.625ZM18.125 23.125L17.5582 22.6338L17.9619 22.168L18.4971 22.4738L18.125 23.125ZM10.5668 32.9912C10.2955 33.3042 9.82182 33.338 9.5088 33.0668C9.19579 32.7955 9.16195 32.3218 9.43323 32.0088L10.5668 32.9912ZM34.4425 25.5017L28.8175 19.2517L29.9325 18.2483L35.5575 24.4983L34.4425 25.5017ZM29.9053 19.2803L23.0303 26.1553L21.9697 25.0947L28.8447 18.2197L29.9053 19.2803ZM22.1279 26.2762L17.7529 23.7762L18.4971 22.4738L22.8721 24.9738L22.1279 26.2762ZM18.6918 23.6162L10.5668 32.9912L9.43323 32.0088L17.5582 22.6338L18.6918 23.6162Z"
        />
      </g>
    </svg>
  );
};
